<app-leveltwo [pageName]="'Real Property Assessments'">
    <div class="General">
      <h3>{{'RealProperty.PageTitle'|translate}}</h3>
      <h4>{{'RealProperty.PagesubTitle'|translate}}</h4>
      <div><p>{{'RealProperty.1stParagraph'|translate}}</p></div>
      <!-- What does the Assessor Do?
      <div>
        <h4 style="font-weight:bold">{{'RealProperty.Whatdoes'|translate}}</h4>
        <h5 style="font-weight:bold">{{'RealProperty.PrimaryResponsibilities'|translate}}</h5>
        <ol>
          <li>{{'RealProperty.LocateTaxableProperty'|translate}}</li>
          <li>{{'RealProperty.EstablishValue'|translate}}</li>
          <li>{{'RealProperty.CompleteAssessmentRoll'|translate}}</li>
          <li>{{'RealProperty.ApplyExemptions'|translate}}</li>
        </ol>

      </div>-->
      <!-- 3 Column section -->
      <!--
      <div class="row">
        <div class="col-sm">
        -->
          <h4 >{{'RealProperty.Prop13header'|translate}}</h4>
          <p>{{'RealProperty.Prop13description'|translate}}</p>
          <p [innerHTML]="'RealProperty.Priorto1978'|translate"></p>
          <p>{{'RealProperty.Essentially'|translate}}</p>

        <!--
        <div class="col-sm">
        -->
          <h4 >{{'RealProperty.ChangeOwnershipheader'|translate}}</h4>
          <p>{{'RealProperty.ChangeOwnershiptext1'|translate}}</p>

          <p>{{'RealProperty.ChangeOwnershiptext2'|translate}}</p>

          <p>{{'RealProperty.ChangeOwnershiptext3'|translate}}</p>

        <!--
        <div class="col-sm">
        -->
          <h4 >{{'RealProperty.NewConstheader'|translate}}</h4>
          <p>{{'RealProperty.NewConsttext1'|translate}}</p>
          <p>{{'RealProperty.NewConsttext2'|translate}}</p>
          <ol>
            <li>{{'RealProperty.Prop13item1'|translate}}</li>
            <li>{{'RealProperty.Prop13item2'|translate}}</li>
            <li>{{'RealProperty.Prop13item3'|translate}}</li>
            <li>{{'RealProperty.Prop13item4'|translate}}</li>
          </ol>
          <!--
          <button type="button" class="btn btn-primary">Sample RP-10 Form</button>
          <br>
          <br>
          <button type="button" class="btn btn-primary">RP-10 Form</button>
          -->



      <div>
        <h4 >{{'RealProperty.Supplementalheader'|translate}}</h4>
        <p>{{'RealProperty.Supplementaltext1'|translate}}</p>
        <p>{{'RealProperty.Supplementaltext2'|translate}}</p>
        <p>{{'RealProperty.Supplementaltext3'|translate}}</p>
        <p>{{'RealProperty.Supplementaltext4'|translate}}</p>
        <p>{{'RealProperty.Supplementaltext5'|translate}}</p>
        <button type="button" class="btn btn-primary" routerLink="/homeowners/supplemental-tax-estimator/">Supplemental Tax Estimator</button>
      </div>

    </div>


</app-leveltwo>
